import { render } from "./PaginaInicio.vue?vue&type=template&id=c698b4f8"
import script from "./PaginaInicio.vue?vue&type=script&lang=js"
export * from "./PaginaInicio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__